import { useTranslation } from '@sm360/hooks'
import { updateDrCalculatorStart } from '@sm360/helpers'
import { Card, CardSection, Icon, InputCurrency, Modal, Select } from '@sm360/ui-library'
import React from 'react'

import { getQuoteDeskingPaymentOptions, getQuoteDeskingPaymentRoll } from '../../../apis/showroom/showroom.service'
import { Context } from '../../../configs/state.manager'
import { payloadPaymentOptionsTransform } from '../../../transforms/payloadPaymentOptions.transform'
import { payloadPaymentRollTransform } from '../../../transforms/payloadPaymentRoll.transform'

const FinanceCard = () => {
    const {
        state,
        state: {
            dealerInfos: { lang },
            paymentOptions: { finance, paymentFrequency, cashDown, tradeIn, lien, disclaimer, __paymentOptionsMeta },
            quoteId,
            vehicle,
        },
        dispatch,
    } = React.useContext(Context)

    const { t } = useTranslation()

    const { payment, apr } = finance?.term || {}

    const metaData = __paymentOptionsMeta.find(({ purchaseMethod }) => purchaseMethod === 'finance')
    const frequencyOptions = metaData.paymentFrequencies.map((item) => {
        return {
            id: item,
            value: item,
            label: t(`pc.paymentFrequency.${item}`),
        }
    })

    const handleChange = async (value) => {
        try {
            const payload = payloadPaymentOptionsTransform({ state, ...value })
            const initPaymentOptions = await getQuoteDeskingPaymentOptions(payload)

            updateDrCalculatorStart(quoteId, vehicle, 'finance')

            dispatch({ type: 'setPaymentOptions', paymentOptions: initPaymentOptions.data })
        } catch (error) {
            console.error(error)
        }
    }

    const handleTargetPaymentChange = async (value) => {
        try {
            const payloadPaymentRoll = payloadPaymentRollTransform({ state, ...value })
            const targetPaymentRoll = await getQuoteDeskingPaymentRoll(payloadPaymentRoll)

            const cashdownUpdate = targetPaymentRoll.data?.negociationTransaction?.cashDown

            const payloadPaymentOptions = payloadPaymentOptionsTransform({ state, cashDown: cashdownUpdate })
            const initPaymentOptions = await getQuoteDeskingPaymentOptions(payloadPaymentOptions)

            updateDrCalculatorStart(quoteId, vehicle, 'finance')

            dispatch({ type: 'setPaymentOptions', paymentOptions: initPaymentOptions.data })
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <div className='pc-financeCard'>
            <Card className='pc-financeCard__wrapper'>
                <CardSection className='pc-financeCard__section'>
                    <div className='pc-financeCard__title'>{t('pc.finance')}</div>

                    <div className='pc-financeCard__resume'>
                        <div className='pc-financeCard__targetPaymentResume'>
                            <InputCurrency
                                id='targetPayment'
                                name='targetPayment'
                                className='pc-financeCard__targetPaymentSelected'
                                value={payment}
                                displayAsText
                                displayWithTwoDecimals
                                locale={lang}
                            />

                            <Modal
                                modalTitle=''
                                trigger={
                                    <span>
                                        <Icon name='info-circle' className='pc-financeCard__icon' />
                                    </span>
                                }
                                className='pc-modal__inner'
                            >
                                <div className='pc-disclaimer'>{disclaimer}</div>
                            </Modal>

                            <div className='pc-financeCard__frequencySelected'>
                                {t(`pc.byPaymentFrequency.${paymentFrequency}`)}
                            </div>
                        </div>
                        <div className='pc-financeCard__rateResume'>
                            <div className='pc-financeCard__rateLabel'>{t('pc.rate')}:</div>
                            <div className='pc-financeCard__rateValue'>{apr}%</div>
                        </div>
                    </div>

                    <InputCurrency
                        id='payment'
                        name='payment'
                        label={t('pc.targetPaymentAmount')}
                        className='pc-financeCard__input pc-financeCard__targetPayment'
                        value={payment}
                        onChange={(v) => handleTargetPaymentChange({ payment: v })}
                        locale={lang}
                    />

                    <Select
                        id='paymentFrequency'
                        name='paymentFrequency'
                        label={t('pc.paymentFrequency')}
                        className='pc-financeCard__input pc-financeCard__frequency'
                        options={frequencyOptions}
                        value={paymentFrequency}
                        onChange={(v) => handleChange({ paymentFrequency: v })}
                    />

                    <InputCurrency
                        id='cashDown'
                        name='cashDown'
                        label={t('pc.cashdown')}
                        className='pc-financeCard__input pc-financeCard__cashDown'
                        value={cashDown}
                        onChange={(v) => handleChange({ cashDown: v })}
                        locale={lang}
                    />

                    <InputCurrency
                        id='tradeIn'
                        name='tradeIn'
                        label={t('pc.tradeInEstimate')}
                        className='pc-financeCard__input pc-financeCard__tradeIn'
                        value={tradeIn}
                        onChange={(v) => handleChange({ tradeIn: v })}
                        locale={lang}
                    />

                    <InputCurrency
                        id='lien'
                        name='lien'
                        label={t('pc.lien')}
                        className='pc-financeCard__input pc-financeCard__lien'
                        value={lien}
                        onChange={(v) => handleChange({ lien: v })}
                        locale={lang}
                    />
                </CardSection>
            </Card>
        </div>
    )
}

export default FinanceCard
